$(document).on('turbo:load', ()=> {
  if ($("#calendar-header").length) { new CalendarHeader($("#calendar-header")); }
});

class CalendarHeader {
  constructor(element){
    this.init_modals = this.init_modals.bind(this);
    this.sync_navigation_to_calendar_filter = this.sync_navigation_to_calendar_filter.bind(this);
    this.container = element;
    this.init_modals();
    this.bind_calendar_filter();
  }

  init_modals() {
    // Need to mount these modals to the body, boostrap issue causes modals to appear behind backstrop when parents are not position:static
    this.container.find("#filter-modal").appendTo("body");
    this.container.find("#quick-month-navigate").appendTo("body");
  }

  bind_calendar_filter() {
    $(document)
      .off("calendar-view-filter-changed.calendarHeader")
      .on("calendar-view-filter-changed.calendarHeader", (event)=> {
        this.sync_navigation_to_calendar_filter(event.originalEvent?.detail?.calendarId);
      });
  }

  sync_navigation_to_calendar_filter(calendarId) {
    const baseId = (window.location.pathname.match(/^\/calendars\/([^/?#]+)/) || [])[1];
    if (!baseId) { return; }

    const targetId = (calendarId == null || calendarId === "") ? "all" : String(calendarId);
    const escaped = baseId.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const links = this.container.find(".previous-month, .next-month, .previous-four-weeks, .next-four-weeks");

    links.add("#quick-month-navigate form").each((_, element)=> {
      const $element = $(element);
      const attribute = element.tagName === "FORM" ? "action" : "href";

      if ($element.data("filterBaseUrl") == null) { $element.data("filterBaseUrl", $element.attr(attribute)); }
      const original = $element.data("filterBaseUrl");
      if (original == null) { return; }

      const next = targetId === baseId ? original : original.replace(new RegExp(`^(/calendars/)${escaped}(/)`), `$1${targetId}$2`);
      $element.attr(attribute, next);
    });
  }
}
